import { Box, Button, FormLabel, MenuItem, Select, Typography } from "@mui/material"
import { MapIssueLog } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useState } from "react";
import { BasicCard } from "../../../components/public/Card";
import UserGrowthChart from "./Chart";
import { CloseIkn, OffIkn, OnIkn } from "../../../utils/icon/Private-Pages/Icon";
import { Model_1 } from "../../../components/public/Model";
import { Textarea } from "../../../components/public/Textarea";


export const AdminDashboard = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filter1, setFilter1] = useState(null);
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState(null)
    const [tableData, setTableData] = useState(MapIssueLog(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [threedotss, setThreeDotss] = useState(true);

    const btns = [
        {
            title: ({ i, rowData }) => {
                return rowData.status?.props?.txt === "Closed" ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <OffIkn />
                        <Typography sx={{ pl: 1 }}>Open</Typography>
                    </Box>
                )
                    :
                    (
                        <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => { setOpen(true) }}>
                            <OnIkn />
                            <Typography sx={{ pl: 1 }}>Close</Typography>
                        </Box>
                    );
            },
            fn: ({ index, i, rowData }) => {
                console.log(
                    "dec",
                    rowData.status?.props?.txt === "Closed",
                    rowData.status,
                    rowData.status?.props?.txt,
                    rowData
                );
            },
            cb: true,
            link: "",
        },
    ];
    const prop = {
        title: 'Issue Log',
        borderBoxStyle: { px: 0 },
        goto: true,
        searchTerm,
        setSearchTerm,
        filteredData: tableData?.map((e) => { const { comments, ...x } = e; return x; }),
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000', },
        tableStyle: { OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        tableProps: { btnData: btns }, tableStyle: { Invoice: false, isThreeDot2: threedotss, OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, threeDot2: { textAlign: "end" }, },
        rowsPerPage,
        page,
        setPage
    }
    const cardDatas = [
        {
            title: 'Total Plan Share Users',
            value: `${Math.round(Math.random() * (100 - 0 + 1)) + 0}K`,
        },
        {
            title: 'Active Plan Share Users',
            value: `${Math.round(Math.random() * (100 - 0 + 1)) + 0}K`,
        },
        {
            title: 'Subscribed Users',
            value: `${Math.round(Math.random() * (100 - 0 + 1)) + 0}K`,
        },
        {
            title: 'Total Templates',
            value: `${Math.round(Math.random() * (100 - 0 + 1)) + 0}K`,
        },
    ]
    return (
        <Box sx={{}}>
            <Model_1 open={open} setOpen={setOpen} data={{ title: 'Nanba', outBoxStyle: { borderRadius: '12px' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ color: '#040815', fontSize: '16px', fontWeight: '600' }}>Comments</Typography>
                    <Button
                        disableRipple
                        disableElevation
                        sx={{ minWidth: "max-content" }}
                        onClick={() => { setOpen(false) }}
                    >
                        <CloseIkn />
                    </Button>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
                    <FormLabel
                        sx={{
                            flexGrow: 1,
                            color: "#000000",
                        }}
                    >
                        Reason*
                    </FormLabel>
                    <Textarea Placeholder={'Describe the fix applied to resolve the issue...'} Value={description} onChange={(e) => { setDescription(e.target.value) }} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <Button disableRipple onClick={() => { setOpen(false) }} sx={{ textTransform: 'capitalize', minHeight: 'max-content', minWidth: 'max-content', height: '26px', width: '64px', background: '#FF2800', color: '#fff', '&:hover': { background: '#FF2800' }, }}>Update</Button>
                </Box>
            </Model_1>
            <Typography sx={{ fontSize: '20px', fontWeight: '600', color: '#000' }}>Dashboard</Typography>
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                {cardDatas?.map((e, i) => (<BasicCard e={{ ...e, outboxStyle: { width: '21%' } }} />))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
                <Typography sx={{ fontSize: '20px', fontWeight: '600', color: '#000' }}>Users</Typography>
                <Select
                    displayEmpty
                    size='small'
                    value={filter1}
                    onChange={(e) => setFilter1(e.target.value)}
                    // inputProps={{ IconComponent: () => null }}
                    // startAdornment={
                    // }
                    sx={{
                        width: "170px",
                        height: "40px",
                        pr: '5px !important',
                        "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            // justifyContent: filter1 === null ? 'end' : 'center',
                            // pl: 0,
                            // pr: '5px !important',
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                            pr: 0
                        },
                    }}>
                    <MenuItem sx={{ display: 'none' }} value={null} disabled>
                        Select Year
                    </MenuItem>
                    <MenuItem value='2024' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>2024</MenuItem>
                    <MenuItem value='2025' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>2025</MenuItem>
                </Select>
            </Box>
            <Box sx={{ maxHeight: '500px', width: '100%', py: 1, borderRadius: '4px', border: '1px solid #E7E8EA' }}>
                <UserGrowthChart />
            </Box>
            {/* <Typography sx={{ fontSize: '20px', fontWeight: '600', color: '#000' }}>Issue Log</Typography> */}
            <PackageTable prop={prop} />
        </Box>
    )
}